<template>
    <div id="InitialSystem">
        <header class="header">
            <img src="../../assets/img/logo2.png" alt class="logo" style="padding-left: 71px;" v-show="!ifGree">
            <img src="../../assets/img/login/logo_page_gree.png" alt class="logo" style="padding-left: 71px;height: 75px" v-show="ifGree">

        </header>
        <div class="title">系统初始配置</div>
        <section class="content-warpper content-warpper-main">
            <div class="trumpet_container">
                <img src="../../assets/img/other/trumpet_icon.png" alt="" class="trumpet_icon">
                请根据贵公司的管理的模式，合理配置配置系统。后期如需修改，请到个人中心/系统设置模块调整。
            </div>

<!--            行业选择-->
<!--            <div>-->
<!--                <span class="header_line"></span>行业选择-->
<!--            </div>-->
<!--            <div class="box">-->
<!--                所属行业：-->
<!--                <el-select v-model="industry" clearable>-->
<!--                    <el-option-->
<!--                            v-for="(item,i) in GetListdata"-->
<!--                            :key="i"-->
<!--                            :label="item.dictName"-->
<!--                            :value="item.id"-->
<!--                    />-->
<!--                </el-select>-->
<!--            </div>-->


            <div>
                <span class="header_line"></span>系统设置
            </div>
            <div class="box">
                <div>活动审批方式</div>
              <div class="radio_container">
                  <div>
                      <el-radio v-model="campaigntype" label="0">由店铺的直属上级审批</el-radio>
                      <span class="info">店铺或经销商申报活动后，默认提交给店铺直属上级审批。</span>
                  </div>
                  <div>
                      <el-radio v-model="campaigntype" label="1">由品类负责人审批</el-radio>
                      <span class="info">店铺或经销商申报活动后，默认提交给活动产品的品类负责人审批。</span>
                  </div>
              </div>
            </div>
            <div class="btn_container">
                <el-button type="confire_btn" @click="confirepost">确认</el-button>
                <el-button @click="toLogin">返回</el-button>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        data:function () {
            return{
                industry:'',
                campaigntype:'',//0 店铺按负责人审批,1 按品类负责人审批
                GetListdata:[],//所属行业
                ifGree:false,
            }
        },
       created(){
           let url=window.location.href
           if(url.indexOf('gree')!=-1) this.ifGree=true
           else  this.ifGree=false
         this.GetList()
       },
        methods:{
            toLogin(){
                const usertype= localStorage.getItem('usertype');
                this.$router.replace(`/login`);
            },
            confirepost(){
                if(this.campaigntype==''){
                    this.$message.warning('请选择活动审批方式')
                    return false
                }
                // if(this.industry==''){
                //     this.$message.warning('请选择所属行业')
                //     return false
                // }
                this.updatecampaigntype()//活动审批
                // this.SetCat()//行业选择
            },
            updatecampaigntype(){
                fetch({url: "hcm/cus/updatecampaigntype", method: "post", data:{campaigntype:this.campaigntype}})
                    .then((res)=>{
                        if(res.status=='10000'){
                            this.$message.success('成功')
                            this.$router.replace({path:'/home'})
                        }
                        else this.$message.error(res.message);
                    })
            },
            SetCat(){
                fetch({url: "hcm/sys/SetCat", method: "post", data:{id:this.industry}})
                    .then((res)=>{
                        if(res.status!='10000') this.$message.error(res.message);
                    })
            },
            cancel(){
                this.$set(this,"campaigntype",'');
                this.$set(this,'industry','')
            },
            GetList(){
                fetch({url: "hcm/sys/GetList", method: "get",params:{dictcode:'category'}})
                    .then((res)=>{
                        if(res.status=='10000')this.GetListdata=res.data
                    })
            }
        }
    }
</script>

<style lang="scss">
    @import "src/style/tableCommon";
    #InitialSystem{
        width: 100%;
        background: url("../../assets/img/login/forget_bg.png") no-repeat;
        background-size: 100% 100%;
        padding-bottom: 50px;
        .content-warpper-main{
            width: 1240px;
            margin: auto;
        }
        .header {
            width: 100%;
            height: 86px;
            background: #fff;
            display: flex;
            align-items: center;
        }
        .title {
            text-align: center;
            font-size: 24px;
            margin: 30px 0;
        }
        .el-radio__input.is-checked .el-radio__inner{
            background: #bda470;
            border-color: #bda470;
        }
        .el-radio__inner{
            width: 21px;
            height: 21px;
        }
        .el-radio__inner::after{
            width: 7px;
            height: 7px;
        }
        .el-radio__input.is-checked+.el-radio__label{
            color:#606266;
        }
        .btn_edit{
            margin:22px 0 42px 0;
        }
        .el-radio{
            width: 230px;
            font-size: 16px;
        }
        .el-radio__label{
            font-size: 16px;
        }
        .radio_container>div{
            margin-top:40px;
        }
        .info{
            font-size: 14px;
            color:#666;
        }
        .el-select{
            width: 30%;
        }
        .box{
            width: 95%;
            padding: 15px 10px 45px 10px;
            box-shadow: 0 4px 5px #efefef;
            border-radius: 10px;
            margin: 30px 0;
        }
        .trumpet_container{
            display: inline-block;
            color:#faad14;
            font-size: 12px;
            height: 28px;
            line-height: 28px;
            margin-bottom: 40px;
            background: #fffbf3;
            padding:0 20px 0 0;
        .trumpet_icon{
            margin-left: 12px;
            width:14px ;
            height: 12px;
            vertical-align: middle;
        }
     }
        .btn_container{
            margin-top: 40px;
            margin-bottom: 50px;
        }
    }
</style>
